<template>
    <div id="browse">
        <Navi currentPage="3"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Results</el-breadcrumb-item>
                    <el-breadcrumb-item>Genes</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div v-if="loading" class="pcga-loading">
                <el-row
                    v-loading="true"
                    element-loading-background="rgba(255, 255, 255, 1)"
                    style="height:100%"
                ></el-row>
                <!-- <pcga-loading></pcga-loading> -->
            </div>
            <div v-if="!loading">
                <div class="results" v-if="!error_page">
                    <div class="task_results">
                        <el-collapse v-model="activeCollapse1">
                            <el-collapse-item name="1">
                                <template slot="title">
                                    <i class="header-icon el-icon-info"></i> Summary of gene
                                </template>
                                <el-descriptions class="margin-top" :column="3" border>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-user"></i>
                                            Gene symbol (HGNC)
                                        </template>
                                        {{ meta['Approved symbol'] }} 
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-mobile-phone"></i>
                                            Previous symbols
                                        </template>
                                        {{ meta['Previous symbols'] }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-mobile-phone"></i>
                                            Alias symbols
                                        </template>
                                        {{ meta['Alias symbols'] }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Chromosome
                                        </template>
                                        {{ meta['Chromosome'] }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-location-outline"></i>
                                            Gene name
                                        </template>
                                        {{ meta['Approved name'] }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Ensembl gene ID
                                        </template>
                                        <el-tag size="middle" type="success">
                                            <el-link
                                                :href="'https://asia.ensembl.org/Homo_sapiens/Gene/Summary?g=' + meta['Ensembl gene ID']"
                                                target="_blank"
                                            >{{ meta['Ensembl gene ID'] }}</el-link>
                                        </el-tag>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-collapse-item>

                            <el-collapse-item name="2">
                                <template slot="title">
                                    <i class="header-icon el-icon-info"></i> Seletive expression and associated phenotypes
                                </template>
                                <el-tabs
                                    type="border-card"
                                    @tab-click="switchRNAdb"
                                    v-model="active_RNAdb"
                                >
                                    <el-tab-pane
                                        v-for="db of rna_db"
                                        :key="db.id"
                                        :label="db.label"
                                        :name="db.id"
                                    ></el-tab-pane>
                                    <div class="context_main_body">
                                        <el-collapse v-model="activeCollapse2">
                                            <el-collapse-item name="1">
                                                <template slot="title">
                                                    <i class="header-icon el-icon-info"></i> Seletive expression
                                                </template>
                                                <div
                                                    class="pcga-result-des"
                                                >Here are seletively expressed tissues/cell types (P &lt; 0.05). The selective expression is measured by REZ (robust Z-score), which is a part of DESE and PCGA 
                                                (see details in Help section). In short, the larger the Z-score, the more selectively the gene is expressed in the tissues/cell types.</div>
                                                <div class="pcga-result-table-box pcga-result-box">
                                                    <div>
                                                        <Tab
                                                            :table_data="cell_table_data"
                                                            :loading="cell_table_data.loading"
                                                            :loadData="loadCellData"
                                                        ></Tab>
                                                    </div>
                                                </div>
                                                <div class="pcga-result-fig-box pcga-result-box" v-if="!cell_box_data.empty">
                                                    <div class="pcga-result-fig1-box">
                                                        <Box
                                                            :fig_data="cell_box_data"
                                                            :loading="cell_box_data.loading"
                                                            :empty="cell_box_data.empty"
                                                        ></Box>
                                                        <Pie
                                                            :fig_data="cell_pie_data"
                                                            :loading="cell_pie_data.loading"
                                                            :empty="cell_pie_data.empty"
                                                        ></Pie>
                                                    </div>
                                                </div>
                                            </el-collapse-item>
                                            <el-collapse-item name="2">
                                                <template slot="title">
                                                    <i class="header-icon el-icon-info"></i> Associated phenotypes
                                                </template>
                                                <div
                                                    class="pcga-result-des"
                                                >Here are associated phenotypes (FDR q-value &lt; 0.1).</div>
                                                <div class="pcga-result-table-box pcga-result-box">
                                                    <div>
                                                        <Tab
                                                            :table_data="phenotype_table_data"
                                                            :loading="phenotype_table_data.loading"
                                                            :loadData="loadPhenotypeData"
                                                        ></Tab>
                                                    </div>
                                                </div>
                                                <div class="pcga-result-fig-box pcga-result-box" v-if="!phenotype_box_data.empty">
                                                    <div class="pcga-result-fig1-box">
                                                        <Box
                                                            :fig_data="phenotype_box_data"
                                                            :loading="phenotype_box_data.loading"
                                                            :empty="phenotype_box_data.empty"
                                                        ></Box>
                                                        <Pie
                                                            :fig_data="phenotype_pie_data"
                                                            :loading="phenotype_pie_data.loading"
                                                            :empty="phenotype_pie_data.empty"
                                                        ></Pie>
                                                    </div>
                                                </div>
                                            </el-collapse-item>
                                        </el-collapse>
                                    </div>
                                </el-tabs>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
                <div class="results" v-else>
                    <el-result icon="error" title="Invalid link" :subTitle="error_msg"></el-result>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Navi from "@/components/navigate.vue";
import Footer from "@/components/footer.vue";
import Tab from "@/components/plot/common_table.vue";
import Box from "@/components/plot/box.vue";
import Pie from "@/components/plot/pie.vue";
// import SPR from "@/components/show_phenotype_result.vue";
import axios from "axios/dist/axios.min";
import { api_dir,echartTable2vxeTable } from "@/bus.js";

export default {
    name: "browse",
    components: { Navi, Footer,Tab,Box,Pie },
    data: function () {
        return {
            activeCollapse1: ['1', '2'],
            activeCollapse2: ['1', '2'],
            error_page: false,
            loading: false,
            id: '',
            error_msg: "The url doesn't contain phenotype ID!",
            rna_db: [
                { 'id': 'gtex', 'label': 'Human tissues' },
                { 'id': 'sc_hs', 'label': 'Human single cell types' },
                { 'id': 'sc_mm', 'label': 'Mouse single cell types' }
            ],
            active_RNAdb: 'gtex',
            tabelData: [],
            loading1: false,
            cols: [],
            cell_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "z", order: "desc" } },
                tableColumn: [
                    { field: 'cell_type_id', title: 'Tissue/cell type ID', width: '30%', msg: { message: 'Tissue/single cell type ID' }, sort: true },
                    { field: 'cell_type', title: 'Tissue/cell type name', width: '25%', msg: { message: 'Tissue/single cell type name' }, sort: true },
                    { field: 'mean', title: 'Mean (CPM)', width: '15%', msg: { message: 'Mean of expression value (CPM, count per million)' }, sort: true },
                    { field: 'z', title: 'Z-score (REZ)', width: '15%', msg: { message: 'Z-score of REZ (for measuring the selective expression)' }, sort: true },
                    { field: 'p', title: 'P-value (REZ)', width: '15%', msg: { message: 'P-value of REZ (for measuring the selective expression)' }, sort: true },
                ],
                tableData: [],
            },
            phenotype_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "CondiECSP", order: "asc" } },
                tableColumn: [
                    { field: 'id', title: 'GWAS ID', width: '20%', msg: { message: 'GWAS ID' }, sort: true },
                    { field: 'trait', title: 'Phenotype name', width: '25%', msg: { message: 'Phenotype description of GWAS' }, sort: true },
                    { field: 'mesh_term', title: 'MeSH term', width: '15%', msg: { message: 'MeSH term of phenotype' }, sort: true },
                    { field: 'category', title: 'Category', width: '10%', msg: { message: 'Category of phenotype' }, sort: true },
                    { field: 'ECSP', title: 'ECS P-value', width: '12%', msg: { message: 'Gene based association P-value calculated by ECS (effective chi-square)' }, sort: true },
                    { field: 'CondiECSP', title: 'Conditional P-value', width: '18%', msg: { message: 'Conditional gene based association P-value, see details in [Help-Framework]' }, sort: true },
                ],
                tableData: [],
            },
            cell_box_data: {
                loading: true,
                width: "550px",
                height: "400px",
                plot_data: {
                    data: [],
                    val_col: '',
                    cate_col: '',
                    name_col:'',
                    detail_cols: [],
                    title: 'Robust Z-score of tissue/cell type',
                    mark_name:'Bonferroni\ncorrection',
                    mark_val:0,
                },
                empty:false
            },
            cell_pie_data: {
                loading: true,
                width: "600px",
                height: "400px",
                plot_data: {
                    data: [],
                    title: 'Category of significant tissue/cell type',
                },
                empty:false
            },
            phenotype_box_data: {
                loading: true,
                width: "550px",
                height: "400px",
                plot_data: {
                    data: [],
                    val_col: '',
                    cate_col: '',
                    detail_cols: [],
                    title: '-log10(Conditional P-value) of phenotypes',
                },
                empty:false
            },
            phenotype_pie_data: {
                loading: true,
                width: "600px",
                height: "400px",
                plot_data: {
                    data: [],
                    title: 'Categories of associated phenotypes',
                },
                empty:false
            },
            meta: {},
        };
    },
    created:function(){
        this.getTaskID();
    },
    mounted: function () {
        this.loadMetaData();
        this.loadPhenotypeData();
        this.loadCellData();
    },

    methods: {
        getTaskID() {
            if ('id' in this.$route.query) {
                this.id = this.$route.query.id;
            } else {
                _this.error_page = true;
            }
        },
        loadMetaData() {
            var ks=['Approved symbol','Approved name','Alias symbols','Chromosome','Ensembl gene ID','Previous symbols']
            var gene_info={}
            for (var k of ks){
                gene_info[k]='NA'
            }

            var _this = this
            var para = { 'action': 'search_gene', 'id': this.id }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    if(res.length>0){
                        _this.meta = res[0];
                    }else{
                        _this.meta =gene_info;
                    }
                })
                .catch(function (error) {
                    _this.meta =gene_info;
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadCellData() {
            var _this = this
            _this.cell_box_data.loading = true;
            _this.cell_pie_data.loading = true;
            _this.cell_table_data.loading = true;
            _this.cell_box_data.empty = false;
            _this.cell_pie_data.empty = false;
            var para = {
                'action': 'gene_assoc_cell_full',
                'gene': this.id,
                'type': this.active_RNAdb
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    //判断是否为空
                    if(res.length==0){
                        _this.cell_box_data.empty = true;
                        _this.cell_pie_data.empty = true;
                        _this.cell_box_data.loading = false;
                        _this.cell_pie_data.loading = false;
                        _this.cell_table_data.tableData=echartTable2vxeTable(res);
                        _this.cell_table_data.loading = false;
                        return
                    }
                    //do table
                    let table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['cell_type_id']='<a target="_blank" class="table_a" href="#/results/cell?id='+s['cell_type_id']+'">'+s['cell_type_id']+'</a>'
                    }
                    _this.cell_table_data.tableData=table_data;
                    _this.cell_table_data.loading = false;
                    //do fig
                    // for (var i = 1; i < res.length; i++) {
                    //     if(res[i][3]==0){
                    //         res[i][3]='16'
                    //     }else{
                    //         res[i][3] = -Math.log10(res[i][3]);
                    //     }
                    // }
                    var switch_name = {
                        'z': 'Robust z-score',
                        'cell_type_id': 'Tissue/Cell type ID',
                        "cell_type": "Tissue/Cell type",
                        "category_cell_type": "Category",
                        'p': 'P-value',
                    }
                    for (var i = 0; i < res[0].length; i++) {
                        res[0][i] = switch_name[res[0][i]];
                    }
                    _this.cell_box_data.plot_data.data = res;
                    _this.cell_box_data.plot_data.val_col = 'Robust z-score';
                    _this.cell_box_data.plot_data.cate_col = 'Category';
                    _this.cell_box_data.plot_data.name_col = 'Tissue/Cell type ID';
                    _this.cell_box_data.plot_data.detail_cols = ['Tissue/Cell type ID', 'Tissue/Cell type', 'Category', 'Robust z-score','P-value'];
                    _this.cell_box_data.plot_data.mark_val=-Math.log10(0.05/(res.length-1));
                    _this.cell_box_data.loading = false;
                    var category_idx = res[0].indexOf('Category');
                    var p_idx = res[0].indexOf('P-value');
                    var k = 0;
                    // var pcut = 0.05 / (res.length - 1);
                    var pcut=1;
                    var map_val = {};
                    for (var i = 1; i < res.length; i++) {
                        if (res[i][p_idx] < pcut) {
                            if (!(res[i][category_idx] in map_val)) {
                                map_val[res[i][category_idx]] = 0;
                            }
                            map_val[res[i][category_idx]] += 1;
                        }
                    }
                    var pdata = []
                    for (var x in map_val) {
                        pdata.push({ name: x, value: map_val[x] });
                    }
                    // console.log(pdata)
                    _this.cell_pie_data.plot_data.data = pdata;
                    _this.cell_pie_data.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadPhenotypeData() {
            var _this = this
            _this.phenotype_box_data.loading = true;
            _this.phenotype_pie_data.loading = true;
            _this.phenotype_table_data.loading = true;
            _this.phenotype_box_data.empty = false;
            _this.phenotype_pie_data.empty = false;
            var para = {
                'action': 'gene_assoc_phenotype_full',
                'gene': this.id,
                'type': this.active_RNAdb
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    //判断是否为空
                    if(res.length==0){
                        _this.phenotype_box_data.empty = true;
                        _this.phenotype_pie_data.empty = true;
                        _this.phenotype_box_data.loading = false;
                        _this.phenotype_pie_data.loading = false;
                        _this.phenotype_table_data.tableData=echartTable2vxeTable(res);
                        _this.phenotype_table_data.loading = false;
                        return
                    }
                    //do table
                    let table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['id']='<a target="_blank" class="table_a" href="#/results/phenotype?id='+s['id']+'">'+s['id']+'</a>'
                    }
                    _this.phenotype_table_data.tableData=table_data;
                    _this.phenotype_table_data.loading = false;
                    //do fig
                    for (var i = 1; i < res.length; i++) {
                        if(res[i][3]==0){
                            res[i][3]=160
                        }else{
                            res[i][3] = -Math.log10(res[i][3]);
                        }
                    }
                    var switch_name = {
                        'CondiECSP': '-log10(Conditional P-value)',
                        'id': 'GWAS ID',
                        "trait": "Phenotype name",
                        "mesh_term": "MeSH term",
                        "category": "Category",
                    }
                    for (var i = 0; i < res[0].length; i++) {
                        res[0][i] = switch_name[res[0][i]];
                    }
                    // console.log(res)
                    _this.phenotype_box_data.plot_data.data = res;
                    _this.phenotype_box_data.plot_data.val_col = '-log10(Conditional P-value)';
                    _this.phenotype_box_data.plot_data.cate_col = 'Category';
                    _this.phenotype_box_data.plot_data.detail_cols = ['GWAS ID', 'Phenotype name', 'Category', '-log10(Conditional P-value)', 'MeSH term'];
                    _this.phenotype_box_data.loading = false;
                    var category_idx = res[0].indexOf('Category');
                    var map_val = {};
                    for (var i = 1; i < res.length; i++) {
                        if (!(res[i][category_idx] in map_val)) {
                            map_val[res[i][category_idx]] = 0;
                        }
                        map_val[res[i][category_idx]] += 1;
                    }
                    var pdata = []
                    for (var x in map_val) {
                        pdata.push({ name: x, value: map_val[x] });
                    }
                    // console.log(pdata)
                    _this.phenotype_pie_data.plot_data.data = pdata;
                    _this.phenotype_pie_data.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        switchRNAdb(tab) {
            this.active_RNAdb = tab.name;
            this.loadPhenotypeData();
            this.loadCellData();
            // console.log(this.active_RNAdb);
        }

    },
};
</script>



<style>
.tip_box {
    padding: 20px 20px;
    background-color: #fdf6ec;
}
.el-collapse-item__header {
    font-size: 16px;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/results/gene.vue